import { makeAutoObservable } from 'mobx'

import type CheckableMap from '@/models/CheckableMap'

import type { StudentWorksheet } from './StudentWorksheet'

export class StudentWorksheetColl {
  constructor(private studentWorksheetMap: CheckableMap<StudentWorksheet['id'], StudentWorksheet>) {
    makeAutoObservable(this)
  }

  get toArr() {
    return this.studentWorksheetMap.toArr
  }

  get checkSize() {
    return this.studentWorksheetMap.checkSize
  }

  get toCheckedValues() {
    return this.studentWorksheetMap.toCheckedValues
  }

  get toCheckedIds() {
    return this.studentWorksheetMap.toCheckedKeys
  }

  get(key: StudentWorksheet['id']) {
    return this.studentWorksheetMap.get(key)
  }

  adds(studentWorksheetColl: StudentWorksheetColl) {
    this.studentWorksheetMap.adds(studentWorksheetColl.studentWorksheetMap.entries())
  }

  get toCheckedWorksheetIds() {
    return this.studentWorksheetMap.toCheckedValues.map(({ worksheet }) => worksheet.id)
  }

  set(key: number, value: StudentWorksheet) {
    this.studentWorksheetMap.set(key, value)
  }

  toggleCheck(key: number) {
    this.studentWorksheetMap.toggleCheck(key)
  }

  delete(key: number) {
    this.studentWorksheetMap.delete(key)
  }

  deletes(keys: number[]) {
    this.studentWorksheetMap.deletes(keys)
  }

  isChecked(key: number) {
    return this.studentWorksheetMap.isChecked(key)
  }

  clearAllCheck() {
    this.studentWorksheetMap.clearAllCheck()
  }
}
